import React from 'react';
import { Container } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { HomeChallengeLeaderboard } from '../../containers/HomeChallengeLeaderboard/HomeChallengeLeaderboard';
import { ChallengeBanner } from './components/ChallengeBanner/ChallengeBanner';
import { useClosestChallenge } from './hooks/useClosestChallenge';
import { NoActiveChallenge } from './components/NoActiveChallenge/NoActiveChallenge';

const NgzChallengesHome = () => {
  const { closestChallenge } = useClosestChallenge();

  return (
    <Container>
      <ChallengeBanner closestChallenge={closestChallenge} />
      {closestChallenge ? (
        <HomeChallengeLeaderboard challengeId={closestChallenge.id} />
      ) : (
        <NoActiveChallenge />
      )}
    </Container>
  );
};

angularizeWithProviders(NgzChallengesHome, 'ngzChallengesHome', {});
